var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Trash_100421",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.511,
    height: 25.646,
    viewBox: "0 0 22.511 25.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M16.7,25.646H5.807c-.891,0-1.738-1-1.892-2.232L1.927,6.69H20.585L18.6,23.414c-.154,1.233-1,2.232-1.892,2.232ZM10.693,22.58a.563.563,0,0,0,1.126,0V9.757a.563.563,0,0,0-1.126,0V22.58Zm3.959-.116a.563.563,0,0,0,1.117.136L17.346,9.872a.563.563,0,0,0-1.117-.136L14.652,22.464ZM6.743,22.6a.563.563,0,0,0,1.117-.136L6.282,9.736a.563.563,0,0,0-1.117.136L6.743,22.6ZM5.7,3.345H1.124a1.115,1.115,0,1,0,0,2.23H21.387a1.115,1.115,0,1,0,0-2.23H16.813V2.228A2.24,2.24,0,0,0,14.561,0H7.951A2.239,2.239,0,0,0,5.7,2.228V3.345Zm2.251,0h6.613c0-.387,0-1.115,0-1.115l-6.611,0V3.345Z",
    fill: "#FF4553",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.73bb46ba9a8fba94691bbd345a6746b0.svg";
export { ForwardRef as ReactComponent };